export function withClerkAuthHeader(
  headers: HeadersInit = {},
  token: string | null | undefined
): Headers {
  const next = new Headers(headers)
  if (token) {
    next.set('Authorization', `Bearer ${token}`)
  }
  return next
}

export function appendClerkTokenToWebSocketUrl(
  url: string,
  token: string | null | undefined
): string {
  if (!token) {
    return url
  }

  const wsUrl = new URL(url, window.location.origin)
  wsUrl.searchParams.set('clerk_token', token)
  return wsUrl.toString()
}
